module.exports = __webpack_public_path__ + "img/navigation.22b5187a.png";